module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "logo",
    on: {
      "click": _vm.logoClicked
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      },
      "exact": ""
    }
  }, [_c('img', {
    staticClass: "dark",
    attrs: {
      "src": require("../assets/images/studio308-logo.png"),
      "id": "logo",
      "alt": "image"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._t("content")], 2), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ae76a66","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageHeader.vue
// module id = 908
// module chunks = 1